<!-- Header -->
<h3 mat-dialog-title *ngIf="type != 'mass-delete'">
  {{title}}
</h3>

<h2 mat-dialog-title style="color: #A20000; text-align: center;" *ngIf="type == 'mass-delete'">WARNING</h2>

<!-- Body -->
<mat-dialog-content translate>
  {{message}}
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">

  <!-- Right Buttons -->
  <div class="footerRight">
    <error-prompt [errorList]="errors"></error-prompt>
    <tyl-button image="save.png" label="Delete" (clickEvent)="OK()"  *ngIf="(!errors || errors.length == 0)"></tyl-button>
    <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancel()"></tyl-button>
  </div>
</mat-dialog-actions>